module.exports = __webpack_public_path__ + "static/media/provider2.9b2054f8.png";